import { render } from "./GuessTheBalance.vue?vue&type=template&id=085aa1e0&scoped=true"
import script from "./GuessTheBalance.vue?vue&type=script&lang=js"
export * from "./GuessTheBalance.vue?vue&type=script&lang=js"

import "./GuessTheBalance.vue?vue&type=style&index=0&id=085aa1e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085aa1e0"]])

export default __exports__